import {
  EntityTypeOld,
  ErrorStateOld,
  INSURANCE_NAME_VALUE,
} from "Store/interfaces/products";
import {
  CalculationPrice,
  FormStates,
} from "Store/priceCalculation/priceCalculationInterfaces";

import { AdvicePriceFormValues } from "Components/Features/CheckPrice/Products/Advice/ProductPrice/AdviceCards/interfaces";
import { AkaAdvicePriceFormValues } from "Components/Features/CheckPrice/Products/Advice/ProductPriceAka/AkaAdviceCards/interfaces";
import { Cart } from "Store/cart/cartInterfaces";
import { InsuranceProduct } from "Store/interfaces/products/checkout";
import { UserIdentificationData } from "Store/userIdentification";

export interface AddProductToCartData {
  readonly coverage: string;
  readonly type: INSURANCE_NAME_VALUE;
  readonly priceData: CalculationPrice;
  readonly customerData: UserIdentificationData | null;
  readonly formData: FormStates;
  readonly storedProduct?: InsuranceProduct | null;
  readonly cartId?: string;
  readonly productId?: string;
}

export interface AddProduct {
  readonly coverage: string;
  readonly type: INSURANCE_NAME_VALUE;
  readonly priceData: CalculationPrice;
  readonly insuredSum?: number;
  readonly oneTimePayment?: number | null;
  readonly productId?: string;
}

export interface AddProductsToCartData {
  readonly isUpsellActive: boolean;
  readonly products: AddProduct[];
  readonly customerData: UserIdentificationData | null;
  readonly formData: FormStates;
  readonly storedProduct?: InsuranceProduct | null;
  readonly cartId?: string;
  readonly productId?: string;
}

export interface AddAdviceProductsToCartStartData {
  readonly formProps: AdvicePriceFormValues;
  readonly redirectToCheckout: boolean;
  readonly takeScreenshot: boolean;
  readonly screenshotRef: HTMLDivElement | null;
  readonly onAdviceCompletedForAdvisor?: (
    shouldCloseAdvisorProductTab: boolean,
  ) => void;
}

export interface AddAkaAdviceProductsToCartStartData {
  readonly formProps: AkaAdvicePriceFormValues;
  readonly redirectToCheckout: boolean;
  readonly takeScreenshot: boolean;
  readonly screenshotRef: HTMLDivElement | null;
  readonly onAdviceCompletedForAdvisor?: (
    shouldCloseAdvisorProductTab: boolean,
  ) => void;
}

export interface AddProductToCartResponse {
  readonly addProductToCartResponse: Cart | undefined;
}

export type AddProductToCartEntity = EntityTypeOld<Cart, OperationType>;

export type AddProductToCartError = ErrorStateOld<OperationType>;

export enum OperationType {
  ADD_PRODUCTS_REQUEST = "ADD_PRODUCTS_REQUEST",
  GET_CART_REQUEST = "GET_CART_REQUEST",
  GET_RECALCULATED_CART_REQUEST = "GET_RECALCULATED_CART_REQUEST",
  GET_CUSTOMER_REQUEST = "GET_CUSTOMER_REQUEST",
  GET_PRODUCT_REQUEST = "GET_PRODUCT_REQUEST",
  UPDATE_PRODUCT_REQUEST = "UPDATE_PRODUCT_REQUEST",
  DELETE_ADVICE_PRODUCT_REQUEST = "DELETE_ADVICE_PRODUCT_REQUEST",
  ADD_ADVICE_PRODUCTS_REQUEST = "ADD_ADVICE_PRODUCTS_REQUEST",
  UPDATE_ADVICE_PRODUCT_REQUEST = "UPDATE_ADVICE_PRODUCT_REQUEST",
}

export interface ApiRequest {
  type: OperationType;
  payload: any;
}
